import { useTrackProcessedNotifications } from '~/features/notifications/hooks/useTrackProcessedNotifications';

// Note: component host so the Header can mount the tracker conditionally (only for roles with the bell)
export const ProcessedNotificationsTracker = () => {
    useTrackProcessedNotifications();
    return null;
};
